import { Dialog, Transition } from "@headlessui/react"
import { XIcon } from "@heroicons/react/outline";
import { Fragment, ReactNode, useRef } from "react";

export interface IModalProps {
  title?: string;
  open: boolean;
  closeOnClickBackdrop?: boolean;
  onClose: () => void;
  children?: ReactNode;
  footer?: ReactNode;
}

export const Modal = ({title = "", children = null, open, closeOnClickBackdrop = true, footer, onClose}: IModalProps) => {
  const dialogRef = useRef(null);
  
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[60]" onClose={() => closeOnClickBackdrop ? onClose() : null} initialFocus={dialogRef ? dialogRef : undefined}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-[60] w-screen overflow-y-auto" ref={dialogRef}>
          <div className="flex h-dvh items-center justify-center p-4 box-border">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform max-h-full flex flex-col rounded-lg bg-white text-left shadow-xl transition-all w-[500px] max-w-full sm:w-fit sm:min-w-[500px] sm:max-w-full ">
                {title ? (
                  <div className="flex items-center justify-between px-4 py-3.5 border-b rounded-t">
                    <h3 className="text-xl font-semibold text-gray-900">
                      {title}
                    </h3>
                    <span
                      className="bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 border-0 ms-auto inline-flex justify-center items-center ring-transparent cursor-pointer"
                      data-modal-hide="static-modal"
                      onClick={onClose}
                    >
                      <XIcon width={20} height={20} />
                    </span>
                  </div>
                ) : (
                  <div className="flex items-center justify-between px-4 py-3.5">
                    <span
                      className="bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 border-0 ms-auto inline-flex justify-center items-center ring-transparent cursor-pointer"
                      data-modal-hide="static-modal"
                      onClick={onClose}
                    >
                      <XIcon width={20} height={20} />
                    </span>
                  </div>
                )}
                <div className="divide-y divide-gray-100 text-sm overflow-y-auto">
                  {children}
                </div>
                {footer ? (
                  <div className="px-4 py-4 sm:px-6 w-full flex justify-center items-center border-t">
                    {footer}
                  </div>
                ) : <></>}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>

  )
}